import { Component } from '@angular/core';
import { AuthHeaderComponent } from "../../../global/auth-header/auth-header.component";
import { FooterComponent } from "../../../global/footer/footer.component";
import { Router } from '@angular/router';

@Component({
  selector: 'app-otp-recover-account-message',
  standalone: true,
  imports: [AuthHeaderComponent, FooterComponent],
  templateUrl: './otp-recover-account-message.component.html',
  styleUrl: './otp-recover-account-message.component.css'
})
export class OtpRecoverAccountMessageComponent {

constructor(
  private router:Router,

){}

  navigateTo(){
    this.router.navigate(['/login']);
  }
}
